const KeenSlider = window.KeenSlider

const { setInitialised, useProgress } = window.BAO.Carousel.plugins

const pendingCarousels = new Set()

const viewportObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      entry.target.hydrateSlides()
      viewportObserver.unobserve(entry.target)
    })
  },
  { rootMargin: '600px 0px' },
)

const observePendingCarousels = () => {
  pendingCarousels.forEach((carousel) => {
    viewportObserver.observe(carousel)
  })

  pendingCarousels.clear()
}

if (document.readyState === 'complete') {
  observePendingCarousels()
} else {
  window.addEventListener('load', observePendingCarousels, { once: true })
}

class ProductCardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide?.exists || this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
    this.queueHydration()

    this.onPointerDown = () => this.hydrateSlides()
    this.addEventListener('pointerdown', this.onPointerDown, { once: true })
  }

  disconnectedCallback () {
    pendingCarousels.delete(this)
    viewportObserver.unobserve(this)
    this.removeEventListener('pointerdown', this.onPointerDown)
    this.carousel?.destroy()
  }

  setupCarousel () {
    const perView = Number(this.dataset.perView)
    const spacing = Number(this.dataset.spacing)

    return new KeenSlider(
      this,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: Number.isFinite(perView) && perView > 0 ? perView : 1,
          spacing: Number.isFinite(spacing) && spacing >= 0 ? spacing : 0,
        },
      },
      [
        setInitialised(),
        useProgress({
          container: this.els.progress?.element,
          progressbar: this.els['progress-bar']?.element,
        }),
      ],
    )
  }

  queueHydration () {
    if (document.readyState === 'complete') {
      viewportObserver.observe(this)
      return
    }

    pendingCarousels.add(this)
  }

  hydrateSlides () {
    if (this.hydrated) return

    this.hydrated = true
    pendingCarousels.delete(this)
    viewportObserver.unobserve(this)

    this.els.deferred?.elements?.forEach((template) => {
      const slide = template.parentElement

      if (!slide) return

      slide.append(template.content.cloneNode(true))
      template.remove()
    })
  }
}

if (!customElements.get('product-card-carousel')) {
  customElements.define('product-card-carousel', ProductCardCarousel)
}
